module.exports = __webpack_public_path__ + "static/img/1.95a5ac65.png";